import { useSearch } from "@sembark-travel/ui/list"
import { ButtonLink, useLocationQuery } from "@sembark-travel/ui/router"
import { useEffect } from "react"
import { Helmet } from "react-helmet-async"
import { CabsList } from "./../../../Cabs"
import { generatePath } from "./../../../router-utils"

export default function Cabs() {
	const [query, setQuery] = useLocationQuery()
	const [params, setParams] = useSearch(query)
	useEffect(() => {
		setQuery(params)
	}, [params, setQuery])
	return (
		<>
			<Helmet>
				<title>Cabs</title>
			</Helmet>
			<CabsList
				params={params}
				setParams={setParams}
				actions={
					<ButtonLink
						to={generatePath("/cabs/new")}
						level="primary"
						status="primary"
					>
						New Cab
					</ButtonLink>
				}
			/>
		</>
	)
}
